<template>
  <div class="page-container page-container--product">
    <div class="product-head">
      <h1 class="product-head__title">
        {{ title }}
      </h1>
      <div class="product-head__details">
        <div class="product-head__reviews">
          <label>
            <span class="visually-hidden">Рейтинг</span>
            <StarRating
              :value="Math.round(+rate)"
              :disabled="true"
              class="product-head__rating"
              :title="Number(rate).toFixed(1)"
              size="medium"
            />
          </label>
          <ReviewsCounter is-product-page
                          not-adaptive
                          :value="+commentsCount"
                          size="medium" />
        </div>
        <ProductCode :code="code" class="product-head__sku" />
      </div>
    </div>
  </div>
</template>

<script>
import StarRating from '@/components/product/StarRating'
import ReviewsCounter from '@/components/product/ReviewsCounter'
import ProductCode from '@/components/product/ProductCode'
import { mapState } from 'vuex'

export default {
  name: 'ProductHead',
  components: {
    StarRating,
    ReviewsCounter,
    ProductCode
  },
  computed: {
    ...mapState({
      title: state => state.productInfo.productInfo.title,
      rate: state => state.productInfo.productInfo.rate,
      rating: state => state.productInfo.productInfo.rating,
      commentsCount: state => state.comments.comments.total_count,
      code: state => state.productInfo.productInfo.code
    })
  }
}
</script>

<style scoped lang="sass">

.product-head__title
  font-size: 18px
  font-weight: 500
  margin: 0 0  20px

  +mmin($tablet)
    font-size: 24px

.product-head__details
  display: flex
  flex-flow: row wrap
  justify-content: space-between
  align-items: center

.product-head__reviews
  display: flex
  flex-flow: row wrap
  align-items: flex-start
  margin-bottom: 5px

.product-head__rating
  margin: 0 10px 0 0

  +mmin($tablet)
    margin: 0 30px 0 0
</style>
